module.exports = __webpack_public_path__ + "img/profile.142a6206.jpg";